import AddressTreeNodesRepository from './AddressTreeNodesRepository';

export default AddressTreeNodesRepository;
